import {createBrowserHistory} from 'history';

import {getCurrentOrg} from 'client/common/hooks/orgs';

const history = createBrowserHistory();

const originalPush = history.push;

const prependSearchParam = (
    searchParams: URLSearchParams,
    params: {key: string; value: string | undefined}
) => {
    if (params.value) {
        searchParams.set(params.key, params.value);
    } else {
        searchParams.delete(params.key);
    }
};

history.push = (loc: Parameters<typeof originalPush>[0]) => {
    const orgId = getCurrentOrg();

    if (typeof loc === 'string') {
        const currentUrl = new URL(loc, location.origin);

        prependSearchParam(currentUrl.searchParams, {
            key: 'org',
            value: orgId && orgId > 0 ? String(orgId) : undefined
        });

        originalPush(`${currentUrl.pathname}${currentUrl.search}`);
    } else {
        const searchParams = new URLSearchParams(loc.search);

        prependSearchParam(searchParams, {
            key: 'org',
            value: orgId && orgId > 0 ? String(orgId) : undefined
        });
        loc.search = searchParams.toString();

        originalPush(loc);
    }
};

export default history;
